import { jsx as _jsx } from "react/jsx-runtime";
import { Line } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import { useMemo, useRef } from 'react';
import * as THREE from 'three';
const SEGMENTS = 96;
const FADE_RATE = 10;
const RENDER_ORDER = 9_000;
/** A circle in the plane through the sphere's center that faces the camera, fading between highlight states. */
export function SilhouetteContour(props) {
    const { radius, color, opacity, width } = props.contour;
    const group = useRef(null);
    const line = useRef(null);
    const shown = useRef(0);
    const lastColor = useRef(color);
    if (opacity > 0)
        lastColor.current = color;
    const eye = useMemo(() => new THREE.Vector3(), []);
    const points = useMemo(() => Array.from({ length: SEGMENTS + 1 }, (_, index) => {
        const angle = index / SEGMENTS * Math.PI * 2;
        return [Math.cos(angle) * radius, Math.sin(angle) * radius, 0];
    }), [radius]);
    useFrame(({ camera }, delta) => {
        if (!group.current || !line.current)
            return;
        camera.getWorldPosition(eye);
        group.current.lookAt(eye);
        shown.current += (opacity - shown.current) * (1 - Math.exp(-FADE_RATE * Math.min(delta, 0.1)));
        line.current.material.opacity = shown.current;
        // Keep the last color while fading out so a vanishing highlight does not flash the rest color.
        line.current.material.color.set(lastColor.current);
        group.current.visible = shown.current > 0.005;
    });
    return (_jsx("group", { ref: group, visible: false, children: _jsx(Line, { ref: (value) => { line.current = value; }, points: points, color: lastColor.current, lineWidth: width, transparent: true, opacity: 0, depthWrite: false, toneMapped: false, renderOrder: RENDER_ORDER, raycast: () => null }) }));
}
